export const UPLOAD_WORKER_COUNT = 2;

export const IMAGE_UPLOAD_MAX_FILE_SIZE = 20971520; // comes from fileUpload.api.ts, also exists in the frontend configuration API
